"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Mounts children only once they're near the viewport.
 * Prevents below-the-fold component JS from loading/executing
 * during initial page load, reducing main-thread work and TBT.
 */
const LazyMount = ({ children, rootMargin = "300px", minHeight }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (visible) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );

    const node = ref.current;
    if (node) observer.observe(node);

    return () => observer.disconnect();
  }, [rootMargin, visible]);

  return (
    <div ref={ref} style={!visible && minHeight ? { minHeight } : undefined}>
      {visible ? children : null}
    </div>
  );
};

export default LazyMount;